import Carousel from './Carousel';
import Swiper, { Scrollbar, Navigation, Keyboard } from 'swiper';
Swiper.use([Scrollbar, Navigation, Keyboard]);
import debounce from 'lodash.debounce';

export default class CarouselProgrammes extends Carousel {
	constructor(elm) {
		super(elm);

		this.boundMouseOverListener = this.mouseOverListener.bind(this);
        this.swiperContainer.addEventListener('mouseover', this.boundMouseOverListener);

        this.boundCheckResize = debounce(this.checkResize.bind(this), 300);
		window.addEventListener('resize', this.boundCheckResize);

		this.slides = this.swiperContainer.querySelectorAll('.swiper-slide');

        this.breakpoint = window.matchMedia('(min-width:768px)');
        if (this.breakpoint.matches === true) {
		    this.initSwiper();
        }
	}

	initSwiper() {
		this.swiper = new Swiper(this.swiperContainer, {
			init: false,
			threshold: 2,
			navigation: {
				prevEl: this.prev,
				nextEl: this.next,
			},
			scrollbar: {
				el: this.scrollbar,
				draggable: true,
				hide: false,
			},
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			spaceBetween: 0,
            slidesPerView: 1,
			breakpoints: {
                768: {
                    slidesPerView: 2
                },
				992: {
					slidesPerView: 3
				},
                1200: {
					slidesPerView: 4
				}
			}
		});
		this.swiper.on('afterInit', (e) => {
			this.checkFooter();
		});

		this.swiper.on('resize', (e) => {
			this.checkFooter();
		});

		this.swiper.init();

	}

    destroySwiper() {
        this.swiper.destroy();
        this.swiper = null;
    }

    checkResize() {
        if (this.breakpoint.matches === true) {
            if(!this.swiper) {
		        this.initSwiper();
            }
        } else {
            if(this.swiper) {
                this.destroySwiper();
            }
        }
    }

    mouseOverListener(e) {
        if (e.target.closest('.swiper-slide')) {
			this.slides.forEach((slide) => {
				slide.classList.remove('swiper-slide-active')
			});
			e.target.closest('.swiper-slide').classList.add('swiper-slide-active');
		}
    }

	checkFooter() {
		if(this.prev.disabled&&this.next.disabled) {
			this.swiperContainer.closest('.section').querySelector('.c-carousel-footer').classList.add('c-carousel-footer--hidden');
			this.swiper.disable();
			this.swiperContainer.classList.add('swiper-disabled');
		} else {
			this.swiperContainer.closest('.section').querySelector('.c-carousel-footer').classList.remove('c-carousel-footer--hidden');
			this.swiper.enable();
			this.swiperContainer.classList.remove('swiper-disabled');
		}
		this.swiper.update();
		window.dispatchEvent(new CustomEvent('refresh-scroll'));
	}

	destroy() {
		this.swiperContainer.removeEventListener('mouseover', this.boundMouseOverListener);
        document.removeEventListener('resize', this.boundResizeCheck);
	}
}
